import { useFormValues } from '../../../core';
import {
  FormValidation,
  FormValidationLength,
  FormValidationMatch,
  FormInitialValues,
  type SingleFormField,
} from '../../../typings';
import type { SingleFieldInnerRenderProps } from './single-field-inner-presenter.types';
import { useFieldWarning, useNotApplicableField } from '../../../hooks';

export function useSingleFieldInnerPresenterContext(
  field: SingleFormField,
  disabled?: boolean,
): SingleFieldInnerRenderProps {
  const fieldName = field.name;
  const matchValidation = field.validations?.find(
    v => v.type === FormValidation.Match,
  );
  const values = useFormValues<FormInitialValues>();
  const isRequiredValidated = Boolean(
    field.validations?.some(v => v.type === FormValidation.Required),
  );

  const isRequired = matchValidation
    ? values[(matchValidation as FormValidationMatch).fieldId] ===
        (matchValidation as FormValidationMatch).value && isRequiredValidated
    : isRequiredValidated;

  const maxLengthValidation = field.validations?.find(
    (v): v is FormValidationLength => v.type === FormValidation.MaxLength,
  );

  const warning = useFieldWarning(field);
  // Same gate SingleFieldPresenter applies to the banner, so the input and the banner
  // can never disagree about whether NA is hiding the warning, even for one render.
  const isFieldNA = useNotApplicableField(field.notApplicableField?.fieldId);

  return {
    field,
    disabled: disabled ?? false,
    fieldName,
    isRequired,
    maxLengthValidation,
    warning: warning !== undefined && !isFieldNA,
  };
}
